// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));

// CONFIGURAÇÃO CRÍTICA PARA O ENDEREÇO /siaap
// Se estiver em produção (no site apmbb.com.br), usa '/siaap' como base.
// Se estiver no seu computador (localhost), usa '/' como base.
const BASE_PATH = process.env.NODE_ENV === 'production' ? "/siaap" : "/"; 

root.render(
  <React.StrictMode>
    {/* O basename diz ao React para ignorar o "/siaap" inicial da URL e tratar o restante como rotas do App */}
    <BrowserRouter basename={BASE_PATH}> 
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();